import { GalaxyToast } from '@dinocloud/galaxy-components-lib';
import { getCurrentLocale } from './utils.service';
class ErrorHandler {
  async translateResponse(response: any) {
    let { code, message } = response;

    switch (code) {
      case 'NotAuthorizedException':
        if (getCurrentLocale() === 'es') {
          switch (message) {
            case 'User is disabled.':
              message = 'El usuario esta deshabilitado';
              break;
            case 'Incorrect username or password.':
              message = 'Usuario o contraseña incorrecta';
              break;
          }
        }
        break;
      case 'CodeDeliveryFailureException':
        if (getCurrentLocale() === 'es') {
          message = 'No se pudo enviar el código.';
        } else {
          message = 'There was an error sending a verification code.';
        }
        break;
      case 'CodeMismatchException' || 'ExpiredCodeException':
        if (getCurrentLocale() === 'es') {
          message =
            'Se proporcionó un código no válido, solicite un código nuevamente.';
        } else {
          message = 'An invalid code was provided, please request it again.';
        }
        break;
      case 'TooManyRequestsException' || 'LimitExceededException':
        if (getCurrentLocale() === 'es') {
          message =
            'Se ha excedido el límite de intentos, intente después de un tiempo.';
        } else {
          message = 'Attempt limit exceeded, try again after a while.';
        }
        break;

      case 'InvalidParameterException':
        switch (message.slice(0, 125)) {
          case `1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal `:
          case `Password did not conform with policy: Password must have numeric characters`:
            if (getCurrentLocale() === 'es') {
              message =
                'La contraseña debe tener un mínimo de seis caracteres y un dígito.';
            } else {
              message =
                'The password must have a minimum of six characters and one digit.';
            }
            break;
          case `Invalid email address format.`:
            if (getCurrentLocale() === 'es') {
              message = 'Formato de email invalido';
            }
            break;
          case `Missing required parameter Session`:
            if (getCurrentLocale() === 'es') {
              message = 'Hubo un error. Vuelva a iniciar sesión.';
            } else {
              message = 'There was a error. Please login again.';
            }
            break;
          case `1 validation error detected: Value at 'username' failed to satisfy constraint: Member must satisfy regular expression pattern`:
            if (getCurrentLocale() === 'es') {
              message = 'Formato de nombre de usuario invalido';
            }
            break;
        }
        break;
      case 'UserLambdaValidationException':
        switch (message) {
          case "The email provided don't belong from a valid domain.":
            if (getCurrentLocale() === 'es') {
              message = 'El email ingresado no pertenece a un dominio valido.';
            }
            break;
          case 'PreSignUp failed with error El usuario ya existe en la user pool antigua, tienen que migrarlo o eliminarlo.':
            if (getCurrentLocale() === 'es') {
              message =
                'El usuario ya existe en la user pool antigua, tienen que migrarlo o eliminarlo.';
            } else {
              message = 'PreSignUp failed with error.';
            }
            break;
        }
        break;
      case 'UsernameExistsException':
        if (getCurrentLocale() === 'es') {
          message = 'El email/nombre de usuario ingresado ya existe.';
        } else {
          message = 'The email/username provided already exists.';
        }
        break;
      default:
        console.log(JSON.stringify(response, null, 4));
        break;
    }
    GalaxyToast({ header: 'Error', message, type: 'error' });
  }
}

const errorHandler = new ErrorHandler();

export default errorHandler;
